import React, { useState } from 'react';
import { useCookies } from 'react-cookie';
import { useIntl, FormattedMessage } from 'react-intl';

import { FormField, FIELD_TYPES } from '@techchange/components';
import { Button, IconButton } from '@techchange/components';
import { messages } from '../../i18n';

import styles from './CookieConfirmation.module.scss';

export const GDPR_ALLOW_ANALYTICS_COOKIE = 'gdpr-allow-analytics-1620405157';

const DATA_PREFERENCES_ANALYTICS = 'analytics';

const TEN_YEARS_IN_MS = 10 * 365 * 24 * 60 * 60 * 1000;

const CookieConfirmation = () => {

	const intl = useIntl();

	const [cookies, setCookie] = useCookies([
		GDPR_ALLOW_ANALYTICS_COOKIE,
	]);

	const [preferences, setPreferences] = useState([]);

	const handleOnChange = (fieldName, fieldValue) => {
		setPreferences(fieldValue);
	};

	const saveCookies = (options = {}) => {

		let allowAnalytics = false;

		if (!options.rejectAll) {
			allowAnalytics = preferences.includes(DATA_PREFERENCES_ANALYTICS);
		}

		setCookie(
			GDPR_ALLOW_ANALYTICS_COOKIE,
			allowAnalytics, {
				path: '/',
				sameSite: true,
				secure: true,
				expires: new Date(Date.now() + TEN_YEARS_IN_MS)
			}
		);

	};

	if (cookies[GDPR_ALLOW_ANALYTICS_COOKIE] !== undefined) {
		return null;
	}

	return (
		<div
			className={styles['cookie-confirmation']}
			role="region"
			aria-labelledby="data-preferences">
			<form>
				<div className="d-flex align-items-center mb-1">
					<div
						className={`me-auto ${styles['cookie-confirmation-header']}`}
						id="data-preferences">
						<FormattedMessage {...messages.TC_COMPONENTS_COOKIE_CONFIRMATION_HEADER} />
					</div>
					<IconButton
						id="tc-policies-link-btn"
						className="tc-policies-link-btn"
						title={intl.formatMessage(messages.TC_COMPONENTS_COOKIE_CONFIRMATION_POLICIES_TITLE)}
						icon={
							<span className="fa-stack text-primary">
								<i className="fas fa-circle fa-stack-2x"></i>
								<i className="fas fa-question fa-stack-1x fa-inverse"></i>
							</span>
						}
						size="1.8em"
						tag={
							<a
								href="/policies/gdpr"
								target="_blank"
								rel="noopener noreferrer nofollow">
								{' '}
							</a>
						}
						tooltip />
				</div>
				<div
					id="data-preferences-description"
					className={styles['cookie-confirmation-description']}>
					<FormattedMessage {...messages.TC_COMPONENTS_COOKIE_CONFIRMATION_DESCRIPTION} />
				</div>
				<div className={styles['preferences-form']}>
					<FormField
						type={FIELD_TYPES.CHECKBOXES}
						name="data-preferences"
						label={intl.formatMessage(messages.TC_COMPONENTS_COOKIE_CONFIRMATION_HEADER)}
						aria-describedby="data-preferences-description"
						value={preferences}
						options={[{
							id: 'analytics-checkbox',
							label: intl.formatMessage(messages.TC_COMPONENTS_COOKIE_CONFIRMATION_ANALYTICS),
							value: DATA_PREFERENCES_ANALYTICS,
						}]}
						isEditing
						isLabelInline
						onChange={handleOnChange} />
					<div className="d-flex ms-auto">
						<Button
							className={styles['preferences-btn']}
							color="primary"
							onClick={saveCookies}>
							<FormattedMessage {...messages.TC_COMPONENTS_COOKIE_CONFIRMATION_ACCEPT} />
						</Button>
						<Button
							className={`${styles['preferences-btn']} ${styles['reject']}`}
							color="primary"
							outline
							onClick={() => saveCookies({ rejectAll: true })}>
							<FormattedMessage {...messages.TC_COMPONENTS_COOKIE_CONFIRMATION_REJECT} />
						</Button>
					</div>
				</div>
			</form>
		</div>
	);

};

export default CookieConfirmation;
